import { appContainer } from '../contexts/app';
import { List } from 'immutable';
import Resource from './resource';
import {
  fromImmutable,
  toImmutable,
  setInState,
  setListInState,
  deleteInState,
  validate
} from './hooks';
import { orderById } from '../lib';

export default app => {
  const service = app.service('api/buildings');

  const BuildingRecord = Resource(
    service,
    {
      account_id: '',
      facility_id: '',
      name: '',
      address: '',
      geo: {},
      floors_order: []
    },
    {
      floors() {
        const floors = appContainer.state.get('floors');
        if (!floors) {
          return List();
        }
        const filtered = floors
          .toList()
          // Filter the floors by those in the floors_order array
          .filter(function(floor) {
            return this.indexOf(floor._id) >= 0;
          }, this.floors_order);
        // Sort the infographics in order
        const sorted = orderById(filtered, this.floors_order);
        return sorted;
      }
    }
  );

  const validateBuilding = validate({
    name: 'Building name is required.'
  });

  appContainer.BuildingRecord = BuildingRecord;
  app.set('BuildingRecord', BuildingRecord);

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [fromImmutable, validateBuilding],
      update: [fromImmutable, validateBuilding],
      patch: [fromImmutable, validateBuilding],
      remove: []
    },

    after: {
      all: [toImmutable(BuildingRecord)],
      find: [setListInState('buildings')],
      get: [setInState('buildings')],
      create: [setInState('buildings')],
      update: [setInState('buildings')],
      patch: [setInState('buildings')],
      remove: [deleteInState('buildings')]
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/buildings.js